/**
 * Returns a handler that smoothly scrolls to a hash anchor.
 * If the href is a plain route (no #), it does nothing special.
 */
export function useSmoothScroll() {
  const scrollTo = (href: string) => {
    if (!href.startsWith('#')) return false; // let caller handle routing

    const id = href === '#' ? null : href.slice(1);

    if (!id) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      const el = document.getElementById(id);
      if (el) {
        const navHeight = 64; // h-16
        const top = el.getBoundingClientRect().top + window.scrollY - navHeight;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    }
    return true;
  };

  return { scrollTo };
}